<template>
  <div class="px-4 sm:px-0 content-visibility-comments">
    <div v-if="!isCommentsVisible" class="u-center w-full px-8 sm:px-16">
      <ShowCommentsButton @click="isCommentsVisible = true" />
    </div>

    <SectionComment v-if="isCommentsVisible"></SectionComment>
    <div ref="articleVisibleEndRef"></div>
  </div>
</template>

<script>
import { defineComponent, provide, ref } from '@nuxtjs/composition-api';
import SectionComment from './SectionComment.vue';
import ShowCommentsButton from './ShowCommentsButton.vue';
import { useInfiniteScroll } from '~/composables/useInfiniteScroll';
import { changeHistory } from '~/modules/article/utils/articleUtils';
import { useWebSocket } from '~/composables/useWebSocket';
import { isAstrolojiContent } from '~/modules/astrology/utils/astrologyUtils';

export default defineComponent({
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  components: { SectionComment, ShowCommentsButton },
  setup(props) {
    const { BindMeta } = useWebSocket();
    const isCommentsVisible = ref(true);
    provide('article', props.item);
    const [articleVisibleEndRef] = useInfiniteScroll(
      () => {
        if (isAstrolojiContent) return;
        if (document.location.pathname === props.item.route) return;
        changeHistory(props.item);
        BindMeta(); // websocket BindMeta
      },
      {
        rootMargin: '-50% 0% 0% 0%',
      }
    );

    return {
      isCommentsVisible,
      articleVisibleEndRef,
    };
  },
});
</script>

<style lang="scss">
.content-visibility-comments {
  contain-intrinsic-size: 100px 1000px;
  content-visibility: visible;
}
</style>
